import { render, staticRenderFns } from "./communicationDashboardPopupsNew.vue?vue&type=template&id=129286ee&scoped=true"
import script from "./communicationDashboardPopupsNew.vue?vue&type=script&lang=js"
export * from "./communicationDashboardPopupsNew.vue?vue&type=script&lang=js"
import style0 from "./communicationDashboardPopupsNew.vue?vue&type=style&index=0&id=129286ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "129286ee",
  null
  
)

export default component.exports